import { InjectionToken } from '@angular/core';
import { AtsUtilityConfig } from '../models';

export const UTILITY_CONFIG = new InjectionToken<AtsUtilityConfig>('Utility Config');
